import ThumbUp from '@material-ui/icons/ThumbUp';
import React from 'react';
import { Button, useNotify, useRefresh } from 'react-admin';
import { json } from '../references.js';


const  ValiderVstButton=(props)=>{
	const notify = useNotify();
	const refresh = useRefresh();

    const save=()=>{
		const { id,montant} = props.data;

    	//alert('Etes vous sure de vouloir payer ce code ?');
    	if ( window.confirm( "Etes vous sure d'avoir reçu le montant de "+montant+" ?" ) ) {
	        if(id){
		        fetch(process.env.REACT_APP_URL+'/vst/status/'+id+'?status=OK', { method: 'PUT',
		        	headers: {
		              "Content-type": "application/json; charset=UTF-8",
		              "Authorization": "Bearer "+ localStorage.getItem('token')
		            }
		    	}).then(json)
		            .then((data) => {
						console.log(data);
		            	if(data.status && data.status==='success'){
							notify(data.message,'success');
							refresh();
		            	}else{
							notify(data.message,'warning');
						}
		            })
		            .catch((e) => {
		                notify('Erreur lors du processus de payement du code', 'warning')
		            });
		            
	          }else{
				notify('Versement inconnu !!', 'warning')
	          }
	    }

    }

    return (<Button  label="Oui" onClick={()=>save()} ><ThumbUp/></Button>);
}

export default ValiderVstButton;


